<template>
  <div class="tekenaarsheader">
    <div class="headerleft">
      <div class="ico">
        <img src="../../../assets/sidebar/home-ico.svg" alt="" />
      </div>
      <h2 class="header">Dashboard</h2> <a target="_blank" class="v2" href="https://cad-tekenaar-dashboard.netlify.app/">Bekijk V2</a>
    </div>

    <div class="rightside">
      <button @click="$emit('showVoegTekenaarToeModal')">+ Voeg tekenaar toe</button>
      <button @click="$emit('showVoegOpdrachtToeModal')">+ Voeg opdracht toe</button>

      <div class="popupLogout" @click="signOut">
        <img src="@/assets/icons/logout-icon.png" alt="" />
        <span>Logout</span>
      </div>
    </div>

    <!-- <SearchfieldWithReset2 :filterOn="tekFilters.name" filterBy="name" /> -->
    <!-- <SearchfieldWithReset :filterOn="tekFilters.name" filterBy="name" /> -->
  </div>
</template>

<script>
import store from '@/store';
//import SearchfieldWithReset from './SearchfieldWithReset'
import firebase from 'firebase/app';

export default {
  name: 'DashboardHeader',
  components: {
    // SearchfieldWithReset,
  },
  computed: {
    tekFilters() {
      return store.state.tekFilters;
    }
  },
  methods: {
    fixupdate(e) {
      store.state.tekFilters.name = e;
    },
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          //   this.$router.replace({
          //     name: 'Videos'
          //   });
        });
    }
  }
};
</script>

<style scoped>

.v2 {
  text-decoration: none;
  color: rgba(0,0,0,0.4);
  cursor: pointer;
  border: 1px solid rgba(0,0,0,0.2);
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 10000px;
}
.header {
  color: #0b1125;

  opacity: 0.8;
  font-weight: 600;
  padding-right: 30px;
  font-size: 26px;
}
.headerleft {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.rightside {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ico {
  background-color: #ff9326;
  width: 28px;
  height: 28px;
  border-radius: 5px;
  padding: 4px;
  margin-right: 10px;
}

.tekenaarsheader {
  z-index: 2;
  /* background-color: #FAFCFE; */
  background-color: #eff2f5;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  display: flex;
  width: 100%;
  height: 70px;
  align-items: center;
  padding: 50px 40px;
  /* border-bottom: 1px solid #E7E7F3; */
}

.searchbarholder {
  position: relative;
}
.reset-btn {
  position: absolute;
  width: 24px;
  height: 24px;
  top: 8px;
  right: 10px;
  cursor: pointer;
}
.searchfield {
  width: 200px;
  height: 40px;
  background-color: #e4ecfa;
  border-radius: 100px;
  border: none;
  font-size: 14px;
  padding: 10px 10px 10px 14px;
}
.active {
  background-color: #3076ea;
  color: white;
}

button {
  transform: translateX(-100px);
  color: #0475f2;
  border: 1px solid #0475f2;
  border-radius: 5px;
  padding: 8px 11px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  background-color: #eff2f5;
  margin-right: 20px;
}
button:hover {
  color: #fff;
  background-color: #0475f2;
}
button:active {
  color: #fff;
  background-color: #1b4d8d;
}

.popupLogout {
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 5px;
  transform: translateX(-100px);
  color: #606979;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;
}
.popupLogout:hover {
}
.popupLogout:hover img,
.popupLogout:hover span {
  transform: translateX(-5px);
}
.popupLogout img {
  max-height: 22px;
  margin-right: 10px;
  transition: 0.2s;
}
.popupLogout span {
  transition: 0.2s;
}
</style>
